import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import Heading from '../../Heading';

// Icons
import BackIcon from '../../../icons/back2.svg';

// Styles
import styles from './NavBar.styl';

const cx = classNames.bind(styles);

export default function NavBar(props) {
  const { className, children, title, onBack, border } = props;

  return (
    <div className={cx('NavBar', className, { NavBar_border: border })}>
      <button className={cx('NavBar__back')} onClick={onBack} type="button">
        <BackIcon className={cx('NavBar__back-icon')} />
      </button>
      <Heading className={cx('NavBar__title')} level={3}>
        {title}
      </Heading>
      <div className={cx('NavBar__children')}>{children}</div>
    </div>
  );
}

NavBar.defaultProps = {
  className: '',
  onBack: undefined,
  title: '',
  children: null,
  border: false,
};

NavBar.propTypes = {
  className: PropTypes.string,
  onBack: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.any,
  border: PropTypes.bool,
};
